import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import busChassisBasicInformationPropTypes from '../proptypes/BusChassisPropTypes';

const BusChassisBasicInformationResource = ({
  make, model, year, numberOfAxles
}) => (
  <>
    <ResourceProperty label="Marca:">{make}</ResourceProperty>
    <ResourceProperty label="Modelo:">
      {model || '-'}
    </ResourceProperty>
    <ResourceProperty label="Año:">
      {year || '-'}
    </ResourceProperty>
    <ResourceProperty label="Número de Ejes:">
      {numberOfAxles || '-'}
    </ResourceProperty>
  </>
);

BusChassisBasicInformationResource.propTypes = busChassisBasicInformationPropTypes;

export default BusChassisBasicInformationResource;
